module.exports = __webpack_public_path__ + "static/media/collection.83e1d447.svg";